export const checksums = {
  "content": "v3.5.0--p7JrdPcrji9U_BoFZmfm3bmD9ZdEDgwY-Ds3f7v8n-E",
  "policies": "v3.5.0--e21Twt5is-z__PbJxnQq7VniABd1dC-wrVUaaLM5p0E",
  "commitments": "v3.5.0--1Et_DU38iPaFP6Kca3RyguypngcgdiJNbOLua_bcZIk"
}
export const checksumsStructure = {
  "content": "bgIYhpjRuV8zbHJE_CfelwKpJ_Td6YuGJwixiek8lmI",
  "policies": "Do1ksdsZVZy4mr2Of-XhYoxTDbOcO9zQjro-yDNmvTM",
  "commitments": "-PWDX23nqe91OF6dZSL6Bv1Wf4ewjCh63huRdEkvq3s"
}

export const tables = {
  "content": "_content_content",
  "policies": "_content_policies",
  "commitments": "_content_commitments",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json"
    }
  },
  "policies": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json"
    }
  },
  "commitments": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}